import DateFormat from "dateformat"
export const ISOToDateAndFullTime = (ISODate) => {
  if (!ISODate || ISODate === "undefined") return ""
  const date = new Date(ISODate)
  const strDate = DateFormat(date, "dddd, mmmm dS, yyyy, HH:MM:ss")
  return strDate
}
export const MMDDYYYYForDatetime = (dateISO = null) => {
  const date = dateISO ? dateISO : new Date()
  const strDate = DateFormat(date, "mm/dd/yyyy")
  return strDate
}
export const ISOToDateYMD = (ISODate) => {
  if (!ISODate || ISODate === "undefined") return ""
  const date = new Date(ISODate)
  const strDate = DateFormat(date, "yyyy/mm/dd")
  return strDate
}
export const ISOToDateYMDAndFullTime = (ISODate) => {
  if (!ISODate || ISODate === "undefined") return ""
  const date = new Date(ISODate)
  const strDate = DateFormat(date, "yyyy/mm/dd HH:MM:ss")
  return strDate
}
export const ISOToDateDMYAndFullTime = (ISODate) => {
  if (!ISODate || ISODate === "undefined") return ""
  const date = new Date(ISODate)
  const strDate = DateFormat(date, "dd/mm/yyyy HH:MM:ss")
  return strDate
}
export const ISOToDateFormat = (ISODate,format = "yyyy/mm/dd") => {
  if (!ISODate || ISODate === "undefined") return ""
  const date = new Date(ISODate)
  const strDate = DateFormat(date, format)
  return strDate
}
export const ISOToDateAndFullTimeNoTime = (ISODate) => {
  if (!ISODate || ISODate === "undefined") return ""
  const date = new Date(ISODate)
  const strDate = DateFormat(date, "dddd, mmmm dS, yyyy")
  return strDate
}
export const ISOToDateAndTimeHHMMSS = (ISODate) => {
  if (!ISODate || ISODate === "undefined") return ""
  const date = new Date(ISODate)
  const strDate = DateFormat(date, "HH:MM:ss")
  return strDate
}

export const CountISODateToNow = (ISODate,ISODateEnd,ignoreSunDay = false) => {
  if (!ISODate || ISODate === "undefined") return ""
  // 3 วัน 23 ชั่วโมง 59 นาที 2 วินาที
  const new_ISODate = DateFormat(new Date(ISODate), "yyyy/mm/dd")
  const new_ISODate_end = DateFormat((ISODateEnd)?new Date(ISODateEnd):new Date(), "yyyy/mm/dd")
  if(new_ISODate == new_ISODate_end){
    if(ISODateEnd){ 
      const date_1 = new Date(ISODateEnd)
      const strDate_1 = DateFormat(date_1, "yyyy/mm/dd HH:MM:ss") 
      return "ติดต่อในวันที่แจ้งเตือน ( เมื่อ : "+strDate_1+") "
    }else{ 
      return "จับเวลาหลังเที่ยงคืนของวันที่ทำแบบสอบถามเรียบร้อย" 
    }
  }
  
  const date_start = new Date(new_ISODate).getTime()
  const date_end = (ISODateEnd)?new Date(ISODateEnd).getTime():new Date().getTime() 
  var total_sec = (date_end - date_start)/1000  
  var res = ""
  var dy = 0
  if(Math.floor(total_sec/86400) > 0){
    dy = Math.floor(total_sec/86400)
    if(dy > 0)dy--

    var has_sunday_in_range = 0;
    if(ignoreSunDay){
      const day = new Date(ISODate).getDay() 
      // console.log("ISODate >>>>> ",ISODate)
      // console.log("day >>>>>>> ",day)
      var r = dy
      var day_name_code = ((day + 1) == 7)?0:day + 1
      // console.log("day_name_code > ",day_name_code) 
      var change_day_to_start_sunday_decreaseDay = (day_name_code != 0)? 7 - day_name_code:0 
      // console.log("change_day_to_start_sunday_decreaseDay > ",change_day_to_start_sunday_decreaseDay) 
      var total_day_by_start_sunday = r - change_day_to_start_sunday_decreaseDay 
      // console.log("total_day_by_start_sunday > ",total_day_by_start_sunday) 
      has_sunday_in_range = Math.ceil(total_day_by_start_sunday / 7) 
      // console.log("has_sunday_in_range > ",has_sunday_in_range) 
      if((r - has_sunday_in_range) > -1){
          dy = dy - has_sunday_in_range
      }
    }
    
    res += dy+" วัน "

    total_sec = total_sec%86400
  }  
  var hr = 0
  if(Math.floor(total_sec/3600) > 0){
    hr = Math.floor(total_sec/3600)
    res += hr+" ชั่วโมง "
    total_sec = total_sec%3600
  } 
  var min = 0 
  if(Math.floor(total_sec/60) > 0){
    min = Math.floor(total_sec/60)
    res += min+" นาที "
    total_sec = total_sec%60
  } 
  var sec = Math.floor(total_sec)
  res += sec+" วินาที"
  console.log(dy,hr,min,sec)

  if(ISODateEnd){
    const date = new Date(ISODateEnd)
    const strDate = DateFormat(date, "yyyy/mm/dd HH:MM:ss")
    res += " ( ติดต่อเมื่อ : "+strDate+") "
  } 



  return res
}